module.exports = __webpack_public_path__ + "img/cuvaison-logo.40f1699d.jpeg";